import * as yup from "yup";
import { validationSchemas } from "./data";

export const unitSchema = yup.object().shape({
  unit: validationSchemas.name,
});
